import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const RouteGuard = ({
  component: Component,
  redPath,
  isAuthenticated,
  returnToFrom = false,
  ...rest
}) => {
  const location = useLocation();

  if (isAuthenticated) {
    return <Component {...rest} />;
  }

  if (returnToFrom && location.state?.from) {
    return <Navigate to={location.state.from} replace />;
  }

  return (
    <Navigate
      to={{ pathname: redPath }}
      state={{ from: `${location.pathname}${location.search}${location.hash}` }}
    />
  );
};

export default RouteGuard;
